<template>
    <div class="title-image" :style="{'background-image': `url(${require(`../assets/img/title-image/${image}.jpg`)})`}">
        <h1 class="text-center h2">
            {{title}}
        </h1>
    </div>
</template>

<script>
export default {
    name: 'TitleImage',
    props:['image', 'title'],
}
</script>
